// @ts-nocheck


import React from 'react';


import { tripApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) =>
<AutocompleteSelect
  fetch={async (params) => {
    return await tripApi.fetchTrips({
      ...filter,
      ...params
    });
  }}
  refetchParams={{ filter }}
  fetchSingle={tripApi.fetchTrip}
  notFoundText="Путевые не найдены"
  placeholder="Выберите путевой"
  renderOption={(trip, Option) =>
  <Option key={trip.id} value={trip.id} trip={trip}>
        {trip.idNumber}
      </Option>
  }
  {...selectProps} />;